import React from 'react';
import styles from '../styles/Welcome.module.scss';
import Login from '../components/Login/Login';
import LightRays from '../components/LightRays/LightRays';
import WelcomeHeader from '../components/WelcomeHeader/WelcomeHeader';
import DemoPreview from '../assets/images/DemoPreview.png';
import Features from '../components/Features/Features';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import BlurText from '../components/BlurText/BlurText';
import Faq from '../components/Faq/Faq';
import Footer from '../components/Footer/Footer';

const Welcome = () => {
  return (
    <div className={styles.welcomeWrapper}>
      <div className={styles.backgroundLayer}>
        <LightRays
          raysOrigin='top-center'
          raysColor='#ffffff'
          raysSpeed={1}
          lightSpread={1}
          rayLength={3}
          followMouse={true}
          mouseInfluence={0.1}
          noiseAmount={0.5}
          distortion={0}
          className='custom-rays'
          pulsating={false}
          fadeDistance={1}
          saturation={1}
        />
      </div>

      <div className={styles.welcome}>
        <WelcomeHeader />
        <div className={styles.welcome__hero}>
          <BlurText
            text="Деньги любят порядок"
            delay={200}
            animateBy='words'
            direction='top'
            className={styles.welcome__title}
          />
          <div className={styles.welcome__desc}>
            Инструмент для тех, кто хочет осознанно управлять своим капиталом
            без лишнего стресса и таблиц.
          </div>
          <div className={styles.welcome__btns}>
            <a href="#how-it-works" className={styles.welcome__btn}>
              Подробнее
            </a>
            <Login
              trigger='Начать бесплатно'
              triggerClassName={styles.welcome__btn}
            />
          </div>
        </div>
        <div className={styles.welcome__images}>
          <img src={DemoPreview} alt='' className={styles.welcome__demo} />
        </div>
        <Features />
        <HowItWorks />
        <Faq />
        <Footer />
      </div>
    </div>
  );
};

export default Welcome;
